<div class="dashboard-container">
  <!-- Header du Dashboard -->
  <div class="dashboard-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="dashboard-title">
            <i class="bi bi-speedometer2 me-2"></i>Tableau de bord
          </h1>
          <p class="dashboard-subtitle">Bienvenue, {{ user?.firstName }} !</p>
        </div>
        <div class="col-md-6 text-md-end">
          <div class="header-actions">
            <button class="btn-action" (click)="refreshData()">
              <i class="bi bi-arrow-clockwise"></i>
            </button>
            <!-- 
            <button class="btn-action" (click)="showNotifications()">
              <i class="bi bi-bell"></i>
              <span class="notification-badge">3</span>
            </button> 
            -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid dashboard-content">
    <!-- KPI Cards -->
    <div class="row g-4 mb-4">
      <div class="col-xl-3 col-md-6">
        <div class="kpi-card kpi-primary">
          <div class="kpi-icon">
            <i class="bi bi-building"></i>
          </div>
          <div class="kpi-content">
            <h3 class="kpi-value">{{ user?.companies?.length || 0 }}</h3>
            <p class="kpi-label">Mes Sociétés</p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-md-6">
        <div class="kpi-card kpi-success">
          <div class="kpi-icon">
            <i class="bi bi-eye"></i>
          </div>
          <div class="kpi-content">
            <h3 class="kpi-value">{{ getTotalViews() }}</h3>
            <p class="kpi-label">Vues Totales</p>
            <!-- 
            <div class="kpi-trend positive">
              <i class="bi bi-arrow-up"></i> +24% cette semaine
            </div>
            -->
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-md-6">
        <div class="kpi-card kpi-warning">
          <div class="kpi-icon">
            <i class="bi bi-star-fill"></i>
          </div>
          <div class="kpi-content">
            <h3 class="kpi-value">{{ getAverageRating() }}/5</h3>
            <p class="kpi-label">Note Moyenne</p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-md-6">
        <div class="kpi-card kpi-info">
          <div class="kpi-icon">
            <i class="bi bi-heart-fill"></i>
          </div>
          <div class="kpi-content">
            <h3 class="kpi-value">{{ user?.favorites?.length || 0 }}</h3>
            <p class="kpi-label">Favoris</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Graphique et Sociétés Visibles -->
    <div class="row g-4 mb-4">
      <!-- Graphique des vues -->
      <div class="col-xl-8">
        <div class="dashboard-card">
          <div class="card-header-dash">
            <div>
              <h3 class="card-title-dash">
                <i class="bi bi-graph-up me-2"></i>Vues Journalières
              </h3>
              <p class="card-subtitle-dash">Évolution des consultations</p>
            </div>
            <!-- 
            <div class="btn-group btn-group-sm" role="group">
              <button type="button" class="btn btn-outline-secondary active">30J</button>
              <button type="button" class="btn btn-outline-secondary">7J</button>
              <button type="button" class="btn btn-outline-secondary">Aujourd'hui</button>
            </div> 
            -->
            <div class="chart-controls">
              <!-- Sélecteur de société -->
              <select class="form-select form-select-sm company-selector"
                (change)="selectCompany($any($event.target).value)">
                <option value="">Toutes les sociétés</option>
                @for(company of user?.companies; track company.data._id) {
                <option [value]="company.data._id">{{ company.data.companyName }}</option>
                }
              </select>

              <!-- Boutons de période -->
              <div class="btn-group btn-group-sm period-buttons" role="group">
                <button type="button" class="btn btn-outline-secondary" [class.active]="selectedPeriod === '1year'"
                  (click)="changePeriod('1year')">
                  1An
                </button>
                <button type="button" class="btn btn-outline-secondary" [class.active]="selectedPeriod === '3months'"
                  (click)="changePeriod('3months')">
                  3M
                </button>
                <button type="button" class="btn btn-outline-secondary" [class.active]="selectedPeriod === '30days'"
                  (click)="changePeriod('30days')">
                  30J
                </button>
                <button type="button" class="btn btn-outline-secondary" [class.active]="selectedPeriod === '7days'"
                  (click)="changePeriod('7days')">
                  7J
                </button>
                <button type="button" class="btn btn-outline-secondary" [class.active]="selectedPeriod === 'today'"
                  (click)="changePeriod('today')">
                  Aujourd'hui
                </button>
              </div>
            </div>
          </div>
          <div class="chart-container">
            <canvas id="viewsChart"></canvas>
          </div>
        </div>
      </div>

      <!-- Sociétés Visibles -->
      <div class="col-xl-4">
        <div class="dashboard-card">
          <div class="card-header-dash">
            <h3 class="card-title-dash">
              <i class="bi bi-eye-fill me-2"></i>Visibilité
            </h3>
          </div>
          <div class="visibility-stats">
            <div class="visibility-item">
              <div class="visibility-label">
                <i class="bi bi-check-circle-fill text-success"></i>
                Sociétés visibles
              </div>
              <div class="visibility-value">{{ getVisibleCompanies() }}</div>
            </div>
            <div class="visibility-item">
              <div class="visibility-label">
                <i class="bi bi-eye-slash-fill text-muted"></i>
                Sociétés masquées
              </div>
              <div class="visibility-value">{{ getHiddenCompanies() }}</div>
            </div>
            <div class="progress-bar-custom mt-3">
              <div class="progress-fill" [style.width.%]="getVisibilityPercentage()"></div>
            </div>
            <p class="text-center mt-2 small text-muted">
              {{ getVisibilityPercentage() }}% de vos sociétés sont visibles
            </p>
          </div>
        </div>

        <!-- Plan d'abonnement -->
        <div class="dashboard-card mt-4">
          <div class="card-header-dash">
            <h3 class="card-title-dash">
              <i class="bi bi-trophy-fill me-2"></i>Mon Plan
            </h3>
          </div>
          <div class="plan-widget">
            <div class="plan-badge">{{ user?.userPlan?.planName || 'Free' }}</div>
            <p class="plan-price">{{ user?.userPlan?.amount || 0 }}€<span>/mois</span></p>
            <p class="plan-status" [class.active]="user?.userPlan?.status === 'active'">
              <i class="bi bi-circle-fill"></i> {{ user?.userPlan?.status || 'inactive' }}
            </p>
            @if(user?.userPlan?.endDate) {
            <p class="plan-expiry">
              Expire le {{ user?.userPlan?.endDate | date:'dd/MM/yyyy' }}
            </p>
            }
            @if(user?.userPlan?.planName != 'premium') {
            <button class="btn-upgrade" (routerLink)="'/profile'">
              <i class="bi bi-arrow-up-circle me-2"></i>Améliorer
            </button>
            }

          </div>
        </div>
      </div>
    </div>

    <!-- Gestion des Sociétés -->
    <div class="row g-4">
      <div class="col-12">
        <div class="dashboard-card">
          <div class="card-header-dash">
            <div>
              <h3 class="card-title-dash">
                <i class="bi bi-buildings me-2"></i>Mes Sociétés
              </h3>
              <p class="card-subtitle-dash">Gérez toutes vos sociétés en un seul endroit</p>
            </div>
            <button class="btn-primary-dash" (click)="addCompany()">
              <i class="bi bi-plus-circle me-2"></i>Ajouter une société
            </button>
          </div>

          @if(addCompanyFormVisible) {
          <div id="company-form" class="company-form-wrapper">
            <app-company-add [currentUser]="user" (companyAdded)="onCompanyAdded($event)"
              (cancelAdd)="addCompanyFormVisible = false"></app-company-add>
          </div>
          }

          <!-- Liste des sociétés -->
          @if (user && user.companies && user.companies.length > 0) {
          <div class="companies-grid">
            @for(company of user.companies; track company.data._id) {
            <div class="company-card" [class.selected]="selectedCompanyId === company.data._id">
              <div class="company-card-header">
                @if(company.data.logo) {
                <img [src]="apiUrl + company.data.logo" alt="Logo" class="company-logo">
                } @else {
                <div class="company-logo-placeholder">
                  <i class="bi bi-building"></i>
                </div>
                }
                <div class="company-status">
                  <span class="status-badge" [class.active]="company.data.isVisible">
                    <i class="bi" [class.bi-eye-fill]="company.data.isVisible"
                      [class.bi-eye-slash-fill]="!company.data.isVisible"></i>
                    {{ company.data.isVisible ? 'Visible' : 'Masqué' }}
                  </span>
                </div>
              </div>

              <div class="company-card-body" (click)="selectCompany(company.data._id)">
                <h4 class="company-name">{{ company.data.companyName }}</h4>
                <p class="company-category">
                  <i class="bi bi-tag me-1"></i>{{ company.data.category }}
                </p>
                <p class="company-role">
                  <i class="bi bi-person-badge me-1"></i>{{ company.role }}
                </p>

                <div class="company-stats">
                  <div class="stat-item">
                    <i class="bi bi-star-fill"></i>
                    <span>{{ company.data.averageRating || 0 }}/5</span>
                  </div>
                  <div class="stat-item">
                    <i class="bi bi-eye"></i>
                    <span>{{ company.data.totalViews }}</span>
                  </div>
                  <div class="stat-item">
                    <i class="bi bi-chat-dots"></i>
                    <span>{{ company.data.comments.length || 0 }}</span>
                  </div>
                </div>

                <!-- Mini graphique de la société -->
                <div class="company-mini-chart">
                  <div class="mini-chart-header">
                    <span class="mini-chart-label">Vues (7 derniers jours)</span>
                    <span class="mini-chart-total">{{ company.data.totalViews }}</span>
                  </div>
                  <canvas [id]="'miniChart-' + company.data._id" class="mini-chart-canvas"></canvas>
                </div>

                <div class="company-info">
                  <p><i class="bi bi-envelope"></i> {{ company.data.companyEmail }}</p>
                  @if(company.data.companyPhoneNumber) {
                  <p><i class="bi bi-telephone"></i> {{ company.data.companyPhoneNumber }}</p>
                  }@else{
                    <p>&nbsp;</p>
                  }
                </div>
              </div>

              <div class="company-card-footer">
                <button class="btn-icon" [routerLink]="'/company/' + company.data._id" title="Voir">
                  <span class="btn-label">Voir</span>
                  <i class="bi bi-eye"></i>
                </button>
                <button class="btn-icon" (click)="editCompany(company.data)" title="Éditer">
                  <span class="btn-label">Éditer</span>
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn-icon" (click)="toggleVisibility(company.data)" title="Visibilité">
                  <span class="btn-label">Visibilité</span>
                  <i class="bi" [class.bi-eye]="!company.data.isVisible"
                    [class.bi-eye-slash]="company.data.isVisible"></i>
                </button>
                <button class="btn-icon btn-danger" (click)="deleteCompany(company.data._id)" title="Supprimer">
                  <span class="btn-label">Supprimer</span>
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
            }
          </div>
          } @else {
          <div class="empty-state">
            <i class="bi bi-building"></i>
            <h3>Aucune société</h3>
            <p>Commencez par ajouter votre première société</p>
            <button class="btn-primary-dash" (click)="addCompany()">
              <i class="bi bi-plus-circle me-2"></i>Créer ma première société
            </button>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="row  mt-2">
      <!-- Activité Récente -->
      <!--
      <div class="col-xl-6">
        <div class="dashboard-card">
          <div class="card-header-dash">
            <h3 class="card-title-dash">
              <i class="bi bi-clock-history me-2"></i>Activité Récente
            </h3>
          </div>
          <div class="activity-list">
            <div class="activity-item">
              <div class="activity-icon bg-success">
                <i class="bi bi-plus-circle"></i>
              </div>
              <div class="activity-content">
                <p class="activity-title">Nouvelle société ajoutée</p>
                <p class="activity-time">Il y a 2 heures</p>
              </div>
            </div>
            <div class="activity-item">
              <div class="activity-icon bg-info">
                <i class="bi bi-pencil"></i>
              </div>
              <div class="activity-content">
                <p class="activity-title">Profil mis à jour</p>
                <p class="activity-time">Il y a 5 heures</p>
              </div>
            </div>
            <div class="activity-item">
              <div class="activity-icon bg-warning">
                <i class="bi bi-star"></i>
              </div>
              <div class="activity-content">
                <p class="activity-title">Nouvel avis reçu</p>
                <p class="activity-time">Hier</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->
      <div class="">
        <div class="dashboard-card">
          <div class="card-header-dash">
            <h3 class="card-title-dash">
              <i class="bi bi-lightning-charge me-2"></i>Actions Rapides
            </h3>
          </div>
          <div class="quick-actions">
            <button class="quick-action-btn" (click)="addCompany()">
              <i class="bi bi-building"></i>
              <span>Nouvelle Société</span>
            </button>
            <button class="quick-action-btn" routerLink="/profile">
              <i class="bi bi-person"></i>
              <span>Mon Profil</span>
            </button>
            <button class="quick-action-btn" routerLink="/favorites">
              <i class="bi bi-heart"></i>
              <span>Mes Favoris</span>
            </button>
            <!-- 
            <button class="quick-action-btn">
              <i class="bi bi-gear"></i>
              <span>Paramètres</span>
            </button> 
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>